import {
  Button,
  ButtonProps,
  InputLabel,
  keyframes,
  Stack,
  styled,
  SxProps,
  TextField,
  Theme,
  Typography,
} from '@mui/material';
import { LinkProps as RouterLinkProps } from 'react-router';

const waveAnimation = keyframes`
  0% {
    background-position: 0 0, 0% center;
  }
  100% {
    background-position: 0 0, 100% center;
  }
`;

export const AnimationAuthWrapperStyled = styled(Stack)(({ theme }) => ({
  backgroundImage: `linear-gradient(rgba(67, 83, 255, 0.85), rgba(67, 83, 255, 0.85)), url(${require('../../assets/images/background.png')})`,
  backgroundPosition: '0 0, 0% center',
  backgroundSize: 'auto, 200% auto',
  backgroundRepeat: 'no-repeat, repeat-x',
  boxShadow: '0 32px 20px 0 rgba(0, 0, 0, 0.04)',
  aspectRatio: '72/43',
  height: '100vh',
  backgroundColor: theme.palette.primary.main,
  justifyContent: 'center',
  alignItems: 'center',
  animation: `${waveAnimation} 30s linear infinite`,
}));

export const SignInWrapperStyled = styled(AnimationAuthWrapperStyled)(({ theme }) => ({
  padding: theme.spacing(4),
  justifyContent: 'flex-start',
}));

export const FormTextLabelStyled = styled(InputLabel)(({ theme }) => ({
  fontSize: '1rem',
  lineHeight: '1.125rem',
  fontWeight: 700,
  color: theme.palette.neutral.main,
}));

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.5, 2),
    // minWidth: '170px',
    height: theme.spacing(3),
    fontSize: '1.125rem',
    fontHeight: '20px',
    fontWeight: 700,
    color: theme.palette.secondary[900],
  },
  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-error fieldset': {
    borderWidth: '2px',
  },
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  border: '1px solid #314053',
  padding: '0 20px',
  color: theme.palette.neutral.main,
  fontSize: '1rem',
  lineHeight: '1.125rem',
  fontWeight: 700,
  background: '#314053',
  height: theme.spacing(6),
  '&.Mui-disabled': {
    background: 'transparent',
    color: '#9AA5FF',
    borderColor: '#9AA5FF',
  },
}));

export const TypographyInfoStyled = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  lineHeight: '1.625rem',
  fontWeight: 700,
  color: theme.palette.neutral.main,
}));

export const ButtonTextStyled = styled(Button)<
  Partial<ButtonProps & Omit<RouterLinkProps, 'variant'>>
>(({ theme }) => ({
  fontSize: '1.25rem',
  lineHeight: '1.625rem',
  fontWeight: 700,
  color: theme.palette.neutral.main,
  textDecoration: 'underline',
}));

export const TooltipSx: SxProps<Theme> = (theme) => ({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  fontWeight: 700,
  color: theme.palette.secondary[900],
  backgroundColor: theme.palette.neutral.main,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
  textAlign: 'center',
  '& .MuiTooltip-arrow': {
    color: theme.palette.neutral.main,
  },
});
